/**
 * One pop-up per app open on Home (Business Rule #64). The Home-screen dialogs
 * (order ready, renew pass, launch pop-up) report here when they open and
 * close, so the launch pop-up can stand aside: it never opens on an app open
 * where another one already showed, and it closes itself if one opens on top.
 * "App open" is the life of the loaded JavaScript — a cold start in the app,
 * a reload on the web.
 */

const openNow = new Set();
const shownThisOpen = new Set();
const listeners = new Set();

/**
 * Report a Home pop-up opening or closing.
 * @param {string} key - e.g. 'ready_pickup', 'renew_pass', 'launch'
 * @param {boolean} isOpen
 */
export function reportHomePopup(key, isOpen) {
  if (isOpen) {
    const fresh = !openNow.has(key);
    openNow.add(key);
    shownThisOpen.add(key);
    if (fresh) listeners.forEach((fn) => fn(key));
  } else {
    openNow.delete(key);
  }
}

/**
 * True when a Home pop-up other than `except` has shown since the app opened.
 * @param {string} [except]
 * @returns {boolean}
 */
export function otherHomePopupShown(except) {
  return [...shownThisOpen].some((k) => k !== except);
}

/**
 * Call `fn(key)` whenever a Home pop-up opens. Returns the unsubscribe function.
 * @param {(key: string) => void} fn
 * @returns {() => void}
 */
export function onHomePopupOpen(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Forget everything (tests only). */
export function resetHomePopups() {
  openNow.clear();
  shownThisOpen.clear();
  listeners.clear();
}
